module.exports = __webpack_public_path__ + "img/quatrieme-couverture-inconnue.5bc335e9.png";